import { Component, TemplateRef, input } from '@angular/core';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { IllustrationComponent } from '@app/components/illustration/illustration.component';
import { Illustration } from '@app/models/global.model';

@Component({
  selector: 'mobi-illustration-section',
  templateUrl: './illustration-section.component.html',
  styleUrls: ['./illustration-section.component.scss'],
  imports: [ComponentSharedModule, IllustrationComponent],
  standalone: true,
})
export class IllustrationSectionComponent {
  readonly illustration = input<Illustration | undefined>();
  readonly content = input.required<TemplateRef<any>>();
  readonly light = input(false);
}
